export class BundleCatalogFormDataModel {
  public mediumType = '';
  public bundleCatalogName = '';
  public startOrderCode = '';
  public startCatalogId = '';
  public endOrderCode = '';
  public endCatalogId = '';
}
